module.exports = __webpack_public_path__ + "79b46809f32f792e3606b743b03493d9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/1_C2.mp3
// module id = 58
// module chunks = 0